import ProfilePagesSummary from "./ProfilePagesSummary";
export default ProfilePagesSummary;
